// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discovery-tasks__separator {
  border-top-color: #ddd;
}

.discovery-tasks__results-preview[readonly] {
  background: #fff;
}

.discovery-tasks__table-wrapper {
  overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/DiscoveryTasks/DiscoveryTasks.css","webpack://./services/frontend/app/components/DiscoveryTasks/DiscoveryTasks.css"],"names":[],"mappings":"AADA;ECEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".discovery-tasks__separator {\n  border-top-color: #ddd;\n}\n\n.discovery-tasks__results-preview[readonly] {\n  background: #fff;\n}\n\n.discovery-tasks__table-wrapper {\n  overflow: visible;\n}\n",".discovery-tasks__separator {\n  border-top-color: #ddd;\n}\n\n.discovery-tasks__results-preview[readonly] {\n  background: #fff;\n}\n\n.discovery-tasks__table-wrapper {\n  overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
